import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const EntryRequirements = () => {
  return (
    <PlaceholderPage title="Entry Requirements">
      Learn about the academic and language requirements for admission to FIC College. 
      Our requirements vary by program and student background.
    </PlaceholderPage>
  );
};

export default EntryRequirements;
